<template>
    <section class="sticky-cta-container" :class="{'sticky-cta-container--hidden' : hidden }">
        <div class="sticky-cta">
            <div class="sticky-cta__content">
                <p
                    v-if="stickyCTA.text"
                    class="sticky-cta__text u-paragraph u-bold"
                >
                    {{ stickyCTA.text }}
                </p>
                <p
                    v-else
                    class="sticky-cta__text u-paragraph u-bold"
                >
                    {{ translation.text }}
                </p>
                <button
                    class="sticky-cta__button"
                    @click="click"
                >
                    <span
                        v-if="stickyCTA.buttonText"
                        class="sticky-cta__button-text u-paragraph u-bold"
                    >
                        {{ stickyCTA.buttonText }}
                    </span>
                    <span
                        v-else
                        class="u-paragraph u-bold"
                    >
                        {{ translation.buttonText }}
                    </span>
                </button>
            </div>
        </div>
    </section>
</template>

<script setup>
import { usePage } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { handleZoeRedirect } from '../../js/utils/zoe-redirect';

const page = usePage();
const stickyCTA = page.props.stickyCta;
const translation = page.props.settings.translations.stickyCta;
const hidden = ref(true);

const click = () => {
    handleZoeRedirect(page.props.zoeRedirect?.link);
};

onMounted(() => {
    const footer = document.querySelector('.footer');
    const header = document.querySelector('.header');

    window.addEventListener('scroll', function () {
        if (footer?.getBoundingClientRect().y - document.documentElement.clientHeight < 0) {
            hidden.value = true;
        } else if (window.scrollY < header?.offsetTop + header.offsetHeight) {
            hidden.value = true;
        } else {
            hidden.value = false;
        }
    });
});

</script>

<style lang="scss">
@use 'watson-theme-sticky-cta';
</style>
